import { useEffect, useState } from 'react';

const kawasanCache = new Map();
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://globizsystems.com/';

async function loadKawasans(type) {
  const cacheKey = type;

  if (!kawasanCache.has(cacheKey)) {
    const params = new URLSearchParams({ type });
    const request = fetch(`${API_BASE_URL}/customers/kawasans?${params}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Unable to load kawasan list');
        }
        return response.json();
      });

    kawasanCache.set(cacheKey, request);
  }

  return kawasanCache.get(cacheKey);
}

function useKawasans(type = 'air') {
  const [kawasans, setKawasans] = useState([]);

  useEffect(() => {
    let active = true;

    loadKawasans(type)
      .then((items) => {
        if (active) {
          setKawasans(items);
        }
      })
      .catch(() => {
        kawasanCache.delete(type);
        if (active) setKawasans([]);
      });

    return () => {
      active = false;
    };
  }, [type]);

  return {
    perumahan: kawasans.filter((kawasan) => kawasan.script === 'perumahan'),
    penjaja: kawasans.filter((kawasan) => kawasan.script === 'penjaja')
  };
}

export default useKawasans;
